import endpointsPaths from "../endpointsPaths/endpointsPaths";
import httpRequest from "../httpRequest";
import httpRequestsPaths from "@helpers/httpRequestsPaths/httpRequestsPaths";

export const getOrdenesKueski = async (idPerfil) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: ordenesKueski } = await httpRequest({
        url: `${endpointsPaths.kueski}/${httpRequestsPaths.pagos.compra.kueski.getOrdenesKueski}`,
        method: "GET",
      });

      resolve(ordenesKueski);
    } catch (error) {
      // console.log("Error al obtener las lecciones: ", error);

      reject(error);
    }
  });
};


export const solicitarCancelacionKueski = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: ordenesKueski } = await httpRequest({
        url: `${endpointsPaths.kueski}/${httpRequestsPaths.pagos.compra.kueski.getKueskiRefund}`,
        method: "POST",
        body: JSON.stringify(data),
      });

      resolve(ordenesKueski);
    } catch (error) {
      // console.log("Error al obtener las lecciones: ", error);

      reject(error);
    }
  });
};

export const getOrdenKueskiByFolio = async (folioContrato) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: ordenKueski } = await httpRequest({
        url: `${endpointsPaths.kueski}/${httpRequestsPaths.pagos.compra.kueski.getOrdenPagoByFolio}/${folioContrato}`,
        method: "GET",
      });

      resolve(ordenKueski);
    } catch (error) {
      // console.log("Error al obtener las lecciones: ", error);

      reject(error);
    }
  });
};
